import { AngularEnvironment } from "./angular-environment";

console.info("Actual environment: development");

export const environment:AngularEnvironment = {
  production: false,
  defaultServerEnvironmentType: "development"
};